import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { MapDispatchToProps, MapStateToProps } from '~commonInfra/utils/ConnectUtils';
import { CompositeSessionInfoSelectors, selectSessionSite, SessionSiteSelectors } from '~src/bootstrap/redux/selectors/SessionInfoSelectors';
import { siteUrlsSelector } from '~src/bootstrap/redux/selectors/SiteUrlsSelectors';
import { contentCountsRequest } from '~src/spacesPlatform/actions/ContentCountsActions';
import { selectContentCounts, selectContentCountsUpToDate } from '~src/spacesPlatform/selectors/ContentCountsSelector';
import { selectSpaceInfo } from '~src/spacesPlatform/selectors/SpaceInfoSelectors';

import { AppState } from '../../bootstrap/redux/state/AppState';
import { selectCatalogingOnSiteEnabled } from '../../catalog/selectors/CatalogSelectors';
import { selectEditingFlowsEnabled,selectFlowsOnSiteEnabled } from '../../flow/selectors/FlowSelectors';
import { DatasourceSpace, DatasourceSpaceDispatchProps, DatasourceSpaceStateProps } from './DatasourceSpace';

const mapStateToProps: MapStateToProps<DatasourceSpaceStateProps> = (state: AppState) => ({
  flowsOnSiteEnabled: selectFlowsOnSiteEnabled(state),
  catalogingOnSiteEnabled: selectCatalogingOnSiteEnabled(state),
  editingFlowsEnabled: selectEditingFlowsEnabled(state),
  spaceInfo: selectSpaceInfo(state),
  urls: siteUrlsSelector(state),
  contentCounts: selectContentCounts<'datasource'>(state, 'datasource'),
  contentCountsUptoDate: selectContentCountsUpToDate(state),
  siteId: selectSessionSite(state).id,
  siteUrlName: SessionSiteSelectors.siteUrlName(state),
  areUsersVisible: !CompositeSessionInfoSelectors.isLimitedUserVisibilityEnforced(state)
});

const mapDispatchToProps: MapDispatchToProps<DatasourceSpaceDispatchProps> =
  (dispatch) => bindActionCreators({
    fetchUpdatedContentCounts: contentCountsRequest
  },
  dispatch);

export const ConnectedDatasourceSpace = connect(mapStateToProps, mapDispatchToProps)(DatasourceSpace);
